export interface IMapInfoWindowBuilder {
  buildMapInfoWindow(data: any, marker: google.maps.marker.AdvancedMarkerElement, currencySymbol?: string): void;
}

export abstract class BaseMapInfoWindowBuilder implements IMapInfoWindowBuilder {
  abstract buildMapInfoWindowHTML(data: any, currencySymbol?: string): string;

  public buildMapInfoWindow(data: any, marker: google.maps.marker.AdvancedMarkerElement, currencySymbol?: string) {

    (marker as any).addListener?.("click", () => {
      const id = marker.dataset['id'];
      const infoWindowContent = this.buildMapInfoWindowHTML(data, currencySymbol);
      google.maps.event.trigger(marker, "map-info-window-open", { id, infoWindowContent });
    });
  }

  protected escapeHTML(value: unknown): string {
    return String(value ?? "N/A")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  protected formatDateTime(ts: Date | string | number): string {
    return new Date(ts).toLocaleString('en-ZA', {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  }
}